import {
  RegularTaskStateTypes,
  RegularTaskActionTypes,
} from "./RegularTask.type";
import { resetApiCallState } from "../Utils";

const INITIAL_STATE: RegularTaskStateTypes = {
  fetchAll: resetApiCallState([]),
  fetchOne: resetApiCallState({}),
};

const RegularTaskReducer = (
  state: RegularTaskStateTypes = INITIAL_STATE,
  action: any
): RegularTaskStateTypes => {
  switch (action.type) {
    case RegularTaskActionTypes.FETCH_ALL_REGULAR_TASK:
      return {
        ...state,
        fetchAll: {
          error: null,
          payload: [],
          isPending: true,
          isSuccessful: false,
        },
      };
    case RegularTaskActionTypes.FETCH_ALL_REGULAR_TASK_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case RegularTaskActionTypes.FETCH_ALL_REGULAR_TASK_FAILURE:
      return {
        ...state,
        fetchAll: {
          payload: [],
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case RegularTaskActionTypes.FETCH_ALL_REGULAR_TASK_SUCCESS:
      return {
        ...state,
        fetchAll: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    case RegularTaskActionTypes.FETCH_ONE_REGULAR_TASK:
      return {
        ...state,
        fetchOne: {
          error: null,
          payload: {},
          isPending: true,
          isSuccessful: false,
        },
      };
    case RegularTaskActionTypes.FETCH_ONE_REGULAR_TASK_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState({}),
      };
    case RegularTaskActionTypes.FETCH_ONE_REGULAR_TASK_FAILURE:
      return {
        ...state,
        fetchOne: {
          payload: {},
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case RegularTaskActionTypes.FETCH_ONE_REGULAR_TASK_SUCCESS:
      return {
        ...state,
        fetchOne: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    default:
      return state;
  }
};

export default RegularTaskReducer;
